import React, { useState, useEffect } from 'react';
import './CalcCeUploadForm.css';
// import './CommonButton.css';
import './CommonProgress.css';
import { useUserContext } from '../../contexts/UserContext';

import { BackendService } from '../../backend/BackendService';
import { CalcCeResult } from './CalcCeData';
import { CommonDropArea } from './CommonDropArea';
import { AvailableCoefficientSet } from '../../backend/generated-rest-client';

type Props = {
    setCalcResult: (calcResult: CalcCeResult) => void
}

const defaultData: CalcCeResult = {
    status: "",
    message: "",
    averageCe: undefined,
    resultListCe: [],
}
export const CalcCeUploadForm: React.FC<Props> = ({setCalcResult}) => {
    const userContext = useUserContext();

    const [message, setMessage] = useState<string>();
    const [error, setError] = useState<string>();
    const [loading, setLoading] = useState<boolean>(false);
    const [selectedOption, setSelectedOption] = useState<string>("");
    const [availCoeSetList, setAvailCoeSetList] = useState<AvailableCoefficientSet[]>(new Array<AvailableCoefficientSet>);

    const dropProp = {
        callbacks: {
            onSetFile: (files: FileList) => {
                const file: File = files[0];
                setCalcResult(defaultData);
                if (1 < files.length) {
                    setMessage('');
                    setError('Multiple files cannot be calculated.');
                    return;
                }
                // 1年分のデータファイル：1.03MB × 1.5 ≒ 1.6MB ≒ 1638KB = 1677312B
                if (1677312 < file.size) {
                    console.log('File is too large. size=' + file.size);
                    setMessage('');
                    setError('"' + file.name + '" is too large. size=' + file.size + ' bytes');
                    return;
                }
                setMessage('Uploading... ' + file.name);
                setError('');
                setLoading(true);
                console.log('Uploading...');
                BackendService.postCalcce(userContext.idToken, file, selectedOption)
                    .then(response => {
                        console.log("BackendService.postCalcce :then");
                        console.log(response);
                        setCalcResult(response);
                        if ("0" === response.status) {
                            setMessage('Uploaded... ' + file.name);
                            setError(response.message);
                        } else {
                            setError(response.message);
                        }
                        setLoading(false);
                        console.log('setCalcResult() done...');
                    })
                    .catch(error => {
                        console.log("BackendService.postCalcce :catch");
                        console.log(error);
                        setLoading(false);
                        userContext.logout();
                        window.location.href = '/';
                    });
            },
            onFailure: (err: string) => {
                console.log('error: ' + err);
                setError(err);
            }
        },
        loading: loading,
        // message: message,
    };

    useEffect(() => {
        BackendService.availableCoefficientSet(userContext.idToken)
        .then(response => {
            console.log("BackendService.availableCoefficient :then userName[" + userContext.userName + "], idToken[" + userContext.idToken + "]");
            console.log(response);

            // ステータス = 0 以外ならエラーメッセージ
            if (response.status == '0') {
                if (response.availableCoefficientSetList != null) {
                    console.log("BackendService.availableCoefficient: SUCCESS");
                    setAvailCoeSetList(response.availableCoefficientSetList)
                }
                // availableCoefficientSetList の最初の要素を selectedOption に設定
                if (response.availableCoefficientSetList && response.availableCoefficientSetList.length >= 1) {
                    setSelectedOption(response.availableCoefficientSetList[0].coefficientSetId ?? "");
                }
            }
            else {
                console.log("Fairue");
            }
        })
        .catch(error => {
            console.log("BackendService.availableCoefficient :catch");
            console.log(error);
            console.log("Fairue");
        });
    }, []);

    return (
        <div className="CalcCeUploadForm_content">
            <div>
                {/* 商標を伏せるため説明文変更 */}
                {/* Welcome to “Online CE”.&nbsp;This current efficiency is just for reference purposes. */}
                Welcome to “CE Calculation Service”.&nbsp;This current efficiency is just for reference purposes.
            </div>
            <br />
            <div className="upload-form-row">
                <CommonDropArea prop={dropProp} />
                <select
                    value={selectedOption}
                    onChange={e => setSelectedOption(e.target.value)}
                    disabled={availCoeSetList.length === 1}>

                    {availCoeSetList.map((coefficientInfo) => (
                        <option value={coefficientInfo.coefficientSetId}>
                            {coefficientInfo.coefficientSetDisplayName}
                        </option>
                    ))}
                </select>
            </div>
            <div>{message}</div>
            <div className="error">{error}</div>
        </div>
    );
};
